import {
  JsonConfiguration2bv2x41u8reet as JsonConfiguration,
  ClassDiscriminatorMode_POLYMORPHIC_getInstance6cczsnt45hfi as ClassDiscriminatorMode_POLYMORPHIC_getInstance,
} from './JsonConfiguration.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DescriptorSchemaCache22yqwocbp420v as DescriptorSchemaCache } from './internal/SchemaCache.mjs';
import { StringJsonWriter17tm33td3svia as StringJsonWriter } from './internal/JsonToStringWriterJsWasm.mjs';
import { encodeByWriter108llwage8l5s as encodeByWriter } from './internal/JsonStreams.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { StringJsonLexer3eu6xom7mrcfu as StringJsonLexer } from './internal/StringJsonLexer.mjs';
import { LexerMode_OBJ_getInstanced06mtz6hd5jq as LexerMode_OBJ_getInstance } from './internal/LexerMode.mjs';
import { StreamingJsonDecoderyo05rsghf9i6 as StreamingJsonDecoder } from './internal/StreamingJsonDecoder.mjs';
import { StringFormat2r2ka8mzcb3mi as StringFormat } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerialFormat.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { JsonSerializersModuleValidator1v682i122jgoa as JsonSerializersModuleValidator } from './internal/JsonSerializersModuleValidator.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClass;
function Default() {
  if (DefaultClass === VOID) {
    class $ extends Json() {
      constructor() {
        Default_instance = null;
        super(new (JsonConfiguration())(), EmptySerializersModule());
        Default_instance = this;
      }
    }
    initMetadataForObject($, 'Default');
    DefaultClass = $;
  }
  return DefaultClass;
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance === VOID)
    new (Default())();
  return Default_instance;
}
var JsonClass;
function Json() {
  if (JsonClass === VOID) {
    class $ {
      constructor(configuration, serializersModule) {
        Default_getInstance();
        this.i2o_1 = configuration;
        this.j2o_1 = serializersModule;
        this.k2o_1 = new (DescriptorSchemaCache())();
      }
      h1s() {
        return this.j2o_1;
      }
      i1o(serializer, value) {
        var result = new (StringJsonWriter())();
        try {
          encodeByWriter(this, result, serializer, value);
          return result.toString();
        }finally {
          result.m2o();
        }
      }
      j1o(deserializer, string) {
        var lexer = StringJsonLexer(this, string);
        var input = new (StreamingJsonDecoder())(this, LexerMode_OBJ_getInstance(), lexer, deserializer.b1n(), null);
        var result = input.r1r(deserializer);
        lexer.a2p();
        return result;
      }
    }
    initMetadataForClass($, 'Json', VOID, VOID, [StringFormat()]);
    JsonClass = $;
  }
  return JsonClass;
}
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new (JsonBuilder())(from);
  builderAction(builder);
  var conf = builder.v2p();
  return new (JsonImpl())(conf, builder.s2p_1);
}
var JsonBuilderClass;
function JsonBuilder() {
  if (JsonBuilderClass === VOID) {
    class $ {
      constructor(json) {
        this.b2p_1 = json.i2o_1.w2p_1;
        this.c2p_1 = json.i2o_1.b2q_1;
        this.d2p_1 = json.i2o_1.x2p_1;
        this.e2p_1 = json.i2o_1.y2p_1;
        this.f2p_1 = json.i2o_1.a2q_1;
        this.g2p_1 = json.i2o_1.c2q_1;
        this.h2p_1 = json.i2o_1.d2q_1;
        this.i2p_1 = json.i2o_1.f2q_1;
        this.j2p_1 = json.i2o_1.m2q_1;
        this.k2p_1 = json.i2o_1.h2q_1;
        this.l2p_1 = json.i2o_1.i2q_1;
        this.m2p_1 = json.i2o_1.j2q_1;
        this.n2p_1 = json.i2o_1.k2q_1;
        this.o2p_1 = json.i2o_1.l2q_1;
        this.p2p_1 = json.i2o_1.g2q_1;
        this.q2p_1 = json.i2o_1.z2p_1;
        this.r2p_1 = json.i2o_1.e2q_1;
        this.s2p_1 = json.h1s();
        this.t2p_1 = json.i2o_1.n2q_1;
        this.u2p_1 = json.i2o_1.o2q_1;
      }
      v2p() {
        if (this.r2p_1) {
          // Inline function 'kotlin.require' call
          if (!(this.i2p_1 === 'type')) {
            var message = 'Class discriminator should not be specified when array polymorphism is specified';
            throw IllegalArgumentException().o2(toString(message));
          }
          // Inline function 'kotlin.require' call
          if (!this.j2p_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
            var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
            throw IllegalArgumentException().o2(toString(message_0));
          }
        }
        if (!this.f2p_1) {
          // Inline function 'kotlin.require' call
          if (!(this.g2p_1 === '    ')) {
            var message_1 = 'Indent should not be specified when default printing mode is used';
            throw IllegalArgumentException().o2(toString(message_1));
          }
        } else if (!(this.g2p_1 === '    ')) {
          var tmp0 = this.g2p_1;
          var tmp$ret$6;
          $l$block: {
            // Inline function 'kotlin.text.all' call
            var inductionVariable = 0;
            while (inductionVariable < charSequenceLength(tmp0)) {
              var element = charSequenceGet(tmp0, inductionVariable);
              inductionVariable = inductionVariable + 1 | 0;
              if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
                tmp$ret$6 = false;
                break $l$block;
              }
            }
            tmp$ret$6 = true;
          }
          var allWhitespaces = tmp$ret$6;
          // Inline function 'kotlin.require' call
          if (!allWhitespaces) {
            var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.g2p_1;
            throw IllegalArgumentException().o2(toString(message_2));
          }
        }
        return new (JsonConfiguration())(this.b2p_1, this.d2p_1, this.e2p_1, this.q2p_1, this.f2p_1, this.c2p_1, this.g2p_1, this.h2p_1, this.r2p_1, this.i2p_1, this.p2p_1, this.k2p_1, this.l2p_1, this.m2p_1, this.n2p_1, this.o2p_1, this.j2p_1, this.t2p_1, this.u2p_1);
      }
    }
    initMetadataForClass($, 'JsonBuilder');
    JsonBuilderClass = $;
  }
  return JsonBuilderClass;
}
function validateConfiguration($this) {
  if (equals($this.h1s(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new (JsonSerializersModuleValidator())($this.i2o_1);
  $this.h1s().t29(collector);
}
var JsonImplClass;
function JsonImpl() {
  if (JsonImplClass === VOID) {
    class $ extends Json() {
      constructor(configuration, module_0) {
        super(configuration, module_0);
        validateConfiguration(this);
      }
    }
    initMetadataForClass($, 'JsonImpl');
    JsonImplClass = $;
  }
  return JsonImplClass;
}
//region block: exports
export {
  Default_getInstance as Default_getInstancevb13yk0g3h3e,
  Json_0 as Jsonsmkyu9xjl7fv,
};
//endregion

//# sourceMappingURL=Json.mjs.map
